import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCollection } from '../../actions/index';

class Portfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      portfolio: [],
    }
  }

  componentWillMount() {
    this.props.getCollection('legal').then(() => {
      if (this.props.collection) {
        this.setState({
          isLoading: false,
          cookies: this.props.collection.entries,
        });
      };
    });
  }

  render() {
    const { isLoading, cookies } = this.state;

    if (isLoading) {
      return <div className="loading" />
    }

    return (
      <div className="cookies-box">
        <h1 className="cookies-title">{cookies[0]["Title"]}</h1>
        <div className="cookies-desc" dangerouslySetInnerHTML={{ __html: cookies[0]["Description"] }}></div>
      </div >
    );
  }
}
function mapStateToProps(state) {
  return { collection: state.collection.collection };
}
export default connect(mapStateToProps, { getCollection })(Portfolio);



// WEBPACK FOOTER //
// ./src/components/about/Cookies.js